import { Decodable } from "./_decodable";

class AdditionalCharge extends Decodable {
    id?: number;
    proposalId?: number;
    title: string = '';
    value: number = 0;
    createdAt?: Date;
    updatedAt?: Date;

    protected _map = {
        createdAt: (e) => this.parseDate(e),
        updatedAt: (e) => this.parseDate(e),
    };
}

export { AdditionalCharge };
